import { createAction, props } from '@ngrx/store';
import { ApiPermissions } from 'src/app/utils/interfaces/auth.interfaces';
import { IDataAction } from '../../utils/interfaces/common.interfaces';

export enum ProxyActionsTypes {  
  GET_AUTH_INFO_XPACPROXY = '[AUTH] GET_AUTH_INFO_XPACPROXY',
  GET_AUTH_INFO_XPACPROXY_SUCCESS = '[AUTH] GET_AUTH_INFO_XPACPROXY_SUCCESS',
  GET_AUTH_INFO_XPACPROXY_FAILED = '[AUTH] GET_AUTH_INFO_XPACPROXY_FAILED',
}

export const getAuthInfoXpacProxyAction = createAction(ProxyActionsTypes.GET_AUTH_INFO_XPACPROXY);
export const getAuthInfoXpacProxySuccessAction = createAction(ProxyActionsTypes.GET_AUTH_INFO_XPACPROXY_SUCCESS, props<IDataAction<ApiPermissions>>());
export const getAuthInfoXpacProxyFailedAction = createAction(ProxyActionsTypes.GET_AUTH_INFO_XPACPROXY_FAILED);